import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';
import './first-image.scss';

const styles = bemGenerator('product-media-first-image', []);

const FirstImage = ({ path, name }) => (
  <div className={styles.block}>
    <img src={path} alt={name} />
  </div>
);

const { string } = PropTypes;
FirstImage.propTypes = {
  path: string.isRequired,
  name: string.isRequired,
};

export default FirstImage;
